import { connect } from 'react-redux';
import { Price, IPriceProps } from '../../components/Price';
import {
  getPriceForObjectFromDeveloperDisplay,
  getPriceForMeterFromDeveloperDisplay,
} from '../../selectors/newbuilding';
import { TApplicationState } from '../../types/redux';

interface IPriceStateProps
  extends Pick<IPriceProps, 'priceForObjectFromDeveloperDisplay'>,
    Pick<IPriceProps, 'priceForMeterFromDeveloperDisplay'> {}

export function mapStateToProps(state: TApplicationState): IPriceStateProps {
  return {
    priceForObjectFromDeveloperDisplay: getPriceForObjectFromDeveloperDisplay(state),
    priceForMeterFromDeveloperDisplay: getPriceForMeterFromDeveloperDisplay(state),
  };
}

export const PriceContainer = connect(mapStateToProps)(Price);
